import Image from '@atlaskit/image';
import avatarTagAnatomyLight from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-anatomy-light.png";
import avatarTagAnatomyDark from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-anatomy-dark.png";
import avatarTagDoLight from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-do-light.png";
import avatarTagDoDark from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-do-dark.png";
import avatarTagDontLight from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-dont-light.png";
import avatarTagDontDark from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-dont-dark.png";
import avatarTag2DoLight from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-2-do-light.png";
import avatarTag2DoDark from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-2-do-dark.png";
import avatarTag2DontLight from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-2-dont-light.png";
import avatarTag2DontDark from "../../../../../../packages/design-system/tag/constellation/avatar-tag/images/avatar-tag-2-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  avatarTagAnatomyLight,
  avatarTagAnatomyDark,
  avatarTagDoLight,
  avatarTagDoDark,
  avatarTagDontLight,
  avatarTagDontDark,
  avatarTag2DoLight,
  avatarTag2DoDark,
  avatarTag2DontLight,
  avatarTag2DontDark,
  React
};